import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  injectTabSlice,
  toReducer
} from '../sliceFactory';

const createUserApplicationsReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'userApplications' });
  const withTabs = injectTabSlice({ initialTab: 0, sliceBase });
  const withTable = injectTableSlice({ sliceBase: withTabs });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createUserApplicationsReducer;
